module.exports = __webpack_public_path__ + "img/empty-archive-boards.34b4b5fe.svg";